import { useFormCompletion } from 'hooks/useFormCompletion';

const RADIUS = 22;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface ProfileCompletionBadgeProps {
  staticPercentage?: number;
  staticSections?: any[];
  isLight?: boolean;
}

const ProfileCompletionBadge = (props: ProfileCompletionBadgeProps) => {
  const { staticPercentage, staticSections, isLight } = props;

  // If static details are provided, use them; otherwise use form context
  const hasStatic = typeof staticPercentage === 'number';
  const dynamicCompletion = useFormCompletion();

  const percentage = hasStatic ? staticPercentage : dynamicCompletion.percentage;
  const sections = hasStatic ? staticSections || [] : dynamicCompletion.sections;

  // A finished profile has nothing left to show progress for.
  if (percentage >= 100) return null;

  const strokeOffset = CIRCUMFERENCE - (percentage / 100) * CIRCUMFERENCE;
  const strokeColor =
    percentage >= 80 ? '#4EB014' : percentage >= 50 ? (isLight ? '#f54900' : '#f59e0b') : '#ef4444';
  const bgCircleStroke = isLight ? '#e5e7eb' : '#333333';
  const labelColor = isLight ? '#1f2937' : '#ffffff';

  return (
    <div
      className={`d-flex align-items-center profile-completion-badge-wrapper ${isLight ? 'is-light' : ''}`}
      title={sections.map((s: any) => `${s.filled ? '✓' : '○'} ${s.label}`).join('\n')}
    >
      <span className={`profile-percentag-text me-2 ${isLight ? 'small fw-medium me-3' : ''}`}>
        {isLight ? 'Profile Completed' : `Profile ${percentage}% Complete`}
      </span>

      <div className="profile-completion-badge">
        <div className="profile-completion-badge__ring-wrapper">
          <svg width={64} height={64} viewBox="0 0 56 56" className="profile-completion-badge__svg">
            <circle
              cx={28}
              cy={28}
              r={RADIUS}
              fill="none"
              stroke={bgCircleStroke}
              strokeWidth={7}
            />
            <circle
              cx={28}
              cy={28}
              r={RADIUS}
              fill="none"
              stroke={strokeColor}
              strokeWidth={7}
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={strokeOffset}
              strokeLinecap="round"
              className="profile-completion-badge__progress-circle"
            />
          </svg>

          <span className="profile-completion-badge__label" style={{ color: labelColor }}>
            {percentage}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionBadge;
